import { Quill } from "react-quill";

const apply = async () => {
  const Font = Quill.import("attributors/class/font");
  Font.whitelist = [
    "arial",
    "comic-sans",
    "courier-new",
    "inter",
    "georgia",
    "helvetica",
    "lucida",
  ];
  Quill.register(Font, true);

  const Size = Quill.import("attributors/class/size");
  Size.whitelist = [
    "12px",
    "14px",
    "16px",
    "18px",
    "20px",
    "24px",
    "28px",
    "32px",
  ];
  Quill.register(Size, true);
};

apply();
